import * as React from 'react';

import { PhraseEditPopupContainer } from '../../containers/PhraseEditPopupContainer/PhraseEditPopupContainer';
import { Bem } from '../../service/Bem/Bem';
import { mapPhraseWithMinusWordsToString } from '../../service/PhrasesHelpers/PhrasesHelpers';

import './ControlledPhraseEditPopup.css';

export interface ControlledPhraseEditPopupProps {
    phraseId: string;
    groupId: string;
    phrase: string;
    minusWords: string[];
    regionIds: number[];
    groupMinusKeywords: string[];
    columnName: string;
}

interface ControlledPhraseEditPopupState {
    isPopupOpen: boolean;
    editPopupValue: string;
}

export class ControlledPhraseEditPopup extends React.PureComponent<
    ControlledPhraseEditPopupProps,
    ControlledPhraseEditPopupState
> {
    private popupAnchor: React.ReactNode | null;

    componentDidUpdate(
        prevProps: ControlledPhraseEditPopupProps,
        prevState: ControlledPhraseEditPopupState
    ) {
        if (
            prevProps.phrase !== this.props.phrase ||
            prevProps.minusWords !== this.props.minusWords
        ) {
            this.setState({
                editPopupValue: mapPhraseWithMinusWordsToString(
                    this.props.phrase,
                    this.props.minusWords
                ),
                isPopupOpen: prevState.isPopupOpen
            });
        }
    }

    constructor(props: ControlledPhraseEditPopupProps) {
        super(props);

        const { phrase, minusWords } = props;

        this.state = {
            editPopupValue: mapPhraseWithMinusWordsToString(phrase, minusWords),
            isPopupOpen: false
        };
    }

    render() {
        const { editPopupValue, isPopupOpen } = this.state;

        const {
            regionIds,
            groupMinusKeywords,
            columnName,
            phraseId,
            groupId
        } = this.props;

        return (
            <span
                className={Bem.cls('controlled-phrase-edit-popup', 'anchor')}
                ref={ref => {
                    this.popupAnchor = ref;
                }}
            >
                <span onClick={this.onChildrenClick}>
                    {this.props.children}
                </span>
                {isPopupOpen ? (
                    <PhraseEditPopupContainer
                        anchor={this.popupAnchor}
                        phraseId={phraseId}
                        groupId={groupId}
                        value={editPopupValue}
                        onChange={this.onChangeValue}
                        onCancel={this.onCancel}
                        regionIds={regionIds}
                        groupMinusKeywords={groupMinusKeywords}
                        columnName={columnName}
                    />
                ) : null}
            </span>
        );
    }

    private onChildrenClick = () => {
        this.setState({
            isPopupOpen: !this.state.isPopupOpen
        });
    };

    private onChangeValue = (value: string) => {
        this.setState({
            editPopupValue: value
        });
    };

    private onCancel = () => {
        this.setState({
            editPopupValue: mapPhraseWithMinusWordsToString(
                this.props.phrase,
                this.props.minusWords
            ),
            isPopupOpen: false
        });
    };
}
